export const tokenKey = "id_token";

export interface Token {
  sub: string;
  name: string;
  email: string;
  role: string;
  username: string;
  permission: string[];
  branchId?: string;
  branches?: string[];
  exp: number;
}

export interface LoginUser {
  id: string;
  name: string;
  email?: string;
  role: SystemRole;
  username: string;
  permissions: string[];
  branchId?: string;
  branches?: string[];
}

export enum SystemRole {
  None = "None",
  BranchStaff = "BranchStaff",
  ResourceAdmin = "ResourceAdmin",
  SystemAdmin = "SystemAdmin"
}

export interface ChangeAdminCreds {
  username: string;
  password: string;
}

export interface Credentials {
  username: string;
  password: string;
  type?: string;
  email?: string;
}
